import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
    AC_ONE_COLUMN_SECTION,
    AC_ONE_COLUMN_SECTION_SELECTOR,
    AC_THREE_COLUMN_SECTION,
    AC_THREE_COLUMN_SECTION_SELECTOR,
    AC_TWO_COLUMN_SECTION,
    AC_TWO_COLUMN_SECTION_SELECTOR,
} from '../../components/constants/canvasview.constants';
import { IAcPalette } from '../interfaces/ac-palette.interface';
import { AcPalette } from '../models/palette/ac-palette.class';

@Injectable({
    providedIn: 'root',
})
export class AcPaletteService {
    paletteLists: IAcPalette[] = [];
    defaultPalettesDependencyOptions = ['show', 'hide'];
    defaultPalettes: any[] = [
        {
            category: 'Content Block',
            label: 'Panel',
            name: 'ac-alpha-panel',
            iconPath: 'assets/icons/accordion.svg',
            version: '1.0.0',
            title: '',
            endIcon: '',
            type: 'accordian',
            prefixIcon: '',
            collapsible: true,
            collapsed: false,
            editForm: true,
            classes: {},
            styles: {},
            selector: 'ac-alpha-panel-1.0.0',
            config: {
                inputs: [
                    {
                        category: 'Panel Properties',
                        attributes: [
                            {
                                uiType: 'typed-input',
                                defaultValue: 'Title',
                                type: 'property',
                                label: 'Title Text',
                                category: 'Text Field Properties',
                                placeholder: 'Enter Text',

                                options: [
                                    {
                                        name: 'String',
                                        value: 'string',
                                    },
                                    {
                                        name: 'Language',
                                        value: 'lang',
                                    },
                                ],
                                fieldMappings: {
                                    value: 'options.title',
                                },
                                value: 'Title',
                            },
                            {
                                uiType: 'drop-down',
                                defaultValue: '',
                                type: 'property',
                                label: 'prefix icon',
                                category: 'Text Field Properties',
                                placeholder: 'Enter icon class',
                                fieldMappings: 'options.prefixIcon',
                                value: 'add',
                            },
                        ],
                    },
                    {
                        category: 'Additional Properties',
                        attributes: [
                            {
                                uiType: 'toggle',
                                defaultValue: false,
                                type: 'property',
                                label: 'Collapsible',
                                category: 'Additional Properties',
                                fieldMappings: 'options.collapsible',
                            },
                            {
                                uiType: 'toggle',
                                defaultValue: false,
                                type: 'property',
                                label: 'Collapsed',
                                fieldMappings: 'options.collapsed',
                                category: 'Additional Properties',
                            },
                        ],
                    },
                ],
                dependencyOptions: this.defaultPalettesDependencyOptions,
            },
        },
        {
            category: 'Content Block',
            label: '1 Column',
            name: AC_ONE_COLUMN_SECTION,
            iconPath: 'assets/icons/1-column.svg',
            version: '1.0.0',
            title: 'Title',
            prefixIcon: 'pi pi-plus',
            classes: {},
            styles: {},
            selector: AC_ONE_COLUMN_SECTION_SELECTOR,
            config: {
                inputs: [
                    {
                        category: 'Section Properties',
                        attributes: [
                            {
                                uiType: 'typed-input',
                                defaultValue: '',
                                type: 'property',
                                label: 'Title Text',
                                category: 'Text Field Properties',
                                placeholder: 'Enter Text',
                                options: [
                                    {
                                        name: 'String',
                                        value: 'string',
                                    },
                                    {
                                        name: 'Language',
                                        value: 'lang',
                                    },
                                ],
                                fieldMappings: {
                                    value: 'options.title',
                                },
                                value: '',
                            },
                            {
                                uiType: 'drop-down',
                                defaultValue: '',
                                type: 'property',
                                label: 'prefix icon',
                                category: 'Text Field Properties',
                                placeholder: 'Enter icon class',
                                fieldMappings: 'options.prefixIcon',
                                value: '',
                            },
                        ],
                    },
                ],
                dependencyOptions: this.defaultPalettesDependencyOptions,
            },
        },
        {
            category: 'Content Block',
            label: '2 Column',
            name: AC_TWO_COLUMN_SECTION,
            iconPath: 'assets/icons/2-column.svg',
            version: '1.0.0',
            title: 'Title',
            prefixIcon: 'pi pi-plus',
            classes: {},
            styles: {},
            selector: AC_TWO_COLUMN_SECTION_SELECTOR,
            config: {
                inputs: [
                    {
                        category: 'Section Properties',
                        attributes: [
                            {
                                uiType: 'typed-input',
                                defaultValue: '',
                                type: 'property',
                                label: 'Title Text',
                                category: 'Text Field Properties',
                                placeholder: 'Enter Text',
                                options: [
                                    {
                                        name: 'String',
                                        value: 'string',
                                    },
                                    {
                                        name: 'Language',
                                        value: 'lang',
                                    },
                                ],
                                fieldMappings: {
                                    value: 'options.title',
                                },
                                value: '',
                            },
                            {
                                uiType: 'drop-down',
                                defaultValue: '',
                                type: 'property',
                                label: 'prefix icon',
                                category: 'Text Field Properties',
                                placeholder: 'Enter icon class',
                                fieldMappings: 'options.prefixIcon',
                                value: '',
                            },
                        ],
                    },
                ],
                dependencyOptions: this.defaultPalettesDependencyOptions,
            },
        },
        {
            category: 'Content Block',
            label: '3 Column',
            name: AC_THREE_COLUMN_SECTION,
            iconPath: 'assets/icons/3-column.svg',
            version: '1.0.0',
            title: 'Title',
            prefixIcon: 'pi pi-plus',
            classes: {},
            styles: {},
            selector: AC_THREE_COLUMN_SECTION_SELECTOR,
            config: {
                inputs: [
                    {
                        category: 'Section Properties',
                        attributes: [
                            {
                                uiType: 'typed-input',
                                defaultValue: '',
                                type: 'property',
                                label: 'Title Text',
                                category: 'Text Field Properties',
                                placeholder: 'Enter Text',
                                options: [
                                    {
                                        name: 'String',
                                        value: 'string',
                                    },
                                    {
                                        name: 'Language',
                                        value: 'lang',
                                    },
                                ],
                                fieldMappings: {
                                    value: 'options.title',
                                },
                                value: '',
                            },
                            {
                                uiType: 'drop-down',
                                defaultValue: '',
                                type: 'property',
                                label: 'prefix icon',
                                category: 'Text Field Properties',
                                placeholder: 'Enter icon class',
                                fieldMappings: 'options.prefixIcon',
                                value: '',
                            },
                        ],
                    },
                ],
                dependencyOptions: this.defaultPalettesDependencyOptions,
            },
        },
    ];

    private emitPaletteList = new BehaviorSubject<IAcPalette[]>([]);

    $paletteList = this.emitPaletteList.asObservable();

    set paletteList(list: Array<IAcPalette>) {
        this.paletteLists = [...this.defaultPalettes, ...list];
        this.emitPaletteList.next(this.paletteLists);
    }

    private palettesMap: Map<string, AcPalette> = new Map<string, AcPalette>();
    private palettesArrayByCategory: {
        categoryId: string;
        category: string;
        palettes: AcPalette[];
    }[] = [];
    private categoryIndexMap: Map<string, number> = new Map<string, number>();

    constructor() {}

    private getCategoryIndex(category: string): number {
        return this.categoryIndexMap.get(category) || -1;
    }

    private getPaletteUUID(palette: {
        libraryName: string;
        libraryVersion: string;
        name: string;
        version: string;
    }): string {
        return `${palette.libraryName}-${palette.libraryVersion}-${palette.name}-${palette.version}`;
    }

    registerPalettes(palettes: AcPalette[]) {
        palettes.forEach((palette) => {
            if (palette instanceof AcPalette) {
                this.registerPalette(palette);
            } else {
                this.registerPalette(new AcPalette(palette));
            }
        });
    }

    registerPalette(palette: AcPalette) {
        if (palette instanceof AcPalette) {
            this.palettesMap.set(this.getPaletteUUID(palette), palette);
            const categoryIndex = this.getCategoryIndex(palette.category);
            if (categoryIndex === -1) {
                this.categoryIndexMap.set(palette.category, this.palettesArrayByCategory.length);
                this.palettesArrayByCategory.push({
                    categoryId: window.crypto.randomUUID(),
                    category: palette.category,
                    palettes: [palette],
                });
            } else {
                this.palettesArrayByCategory[categoryIndex].palettes.push(palette);
            }
        }
    }

    getPalette(options: { libraryName: string; libraryVersion: string; name: string; version: string }) {
        return this.palettesMap.get(
            this.getPaletteUUID({
                libraryName: options.libraryName,
                libraryVersion: options.libraryVersion,
                name: options.name,
                version: options.version,
            }),
        );
    }

    getPalleteConfig(options: { name: string; version: string }) {
        const palette = this.paletteLists.find((p) => p.name === options.name && p.version === options.version) || {};
        return structuredClone(palette.config);
    }

    getPalettesUIJSON(): { category: string; palettes: AcPalette[] }[] {
        return this.palettesArrayByCategory;
    }
}
